import * as React from 'react';
import { SVGProps } from 'react';

const SvgRibbon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill={props.fill}
      d="m29.16 37.37-8.19-8.19 3.64-3.64 4.54 4.54.02 7.29h-.01Z"
    />
    <path
      fill="currentColor"
      d="M28.26 6.39A11.565 11.565 0 0 0 20.08 3c-3.07 0-6.01 1.23-8.18 3.4-2.18 2.17-3.4 5.11-3.4 8.18.04 1.14.3 2.26.78 3.3a14.39 14.39 0 0 0 3.16 4.63l2.21 2.2L8 31.35l5.47 5.46 14.21-14.25c1.82-1.81 3.98-4.68 3.98-7.98 0-3.07-1.22-6.01-3.39-8.18l-.01-.01Zm-8.16 4.33c.61 0 1.22.15 1.76.43.55.28 1.02.69 1.38 1.19a3.276 3.276 0 0 1 .3 3.09c-.17.43-.42.82-.75 1.14l-2.68 2.68-2.69-2.69c-.32-.32-.57-.69-.74-1.11-.23-.55-.31-1.14-.23-1.73.08-.59.32-1.14.69-1.61.36-.43.82-.78 1.33-1.02.51-.24 1.06-.36 1.63-.36v-.01Zm0-5.15c.5 0 1 .04 1.48.13 1.49.25 2.82 1.06 3.62 2.34.6.96.9 1.99.93 3.06.01.41-.03.81-.09 1.21a6.03 6.03 0 0 0-.74-1.48 6.443 6.443 0 0 0-7.93-2.05c-.85.4-1.61.98-2.21 1.7a5.83 5.83 0 0 0-1.2 2.55c-.24-.73-.37-1.47-.34-2.22.02-.78.21-1.53.55-2.25.51-1.08 1.47-1.88 2.58-2.33 1.11-.45 2.19-.65 3.34-.65l.01-.01Zm-5.82 15.1a12.103 12.103 0 0 1-2.61-3.8c-.34-.72-.53-1.5-.58-2.3 0-1.49.37-2.94 1.06-4.23-.01.13-.03.26-.03.4-.13 4.12 3.24 7.73 5.99 10.48l-1.65 1.64-2.19-2.19h.01Zm11.6.08L13.46 33.17l-1.82-1.82 10.54-10.54c.8-.75 1.61-1.52 2.37-2.37l.05-.05c.23-.23.43-.47.61-.73 1.39-1.75 2.42-3.83 2.42-6.61 0-.6-.09-1.18-.25-1.75a8.992 8.992 0 0 1 1.73 5.28c0 2.57-2.02 4.97-3.23 6.18v-.01Z"
    />
  </svg>
);

export default SvgRibbon;
